/* eslint-disable no-undef */
import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import MainLayout from '../../containers/MainLayout/MainLayout';
import MainSearch from '../../containers/MainSearch/MainSearch';
import AccordionItem from './AccordionItem/AccordionItem';
import FAQPageRightPart from '../../containers/FAQPage/FAQPageRightPart';
import './FAQPage.sass';

const FAQPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const { footerData, faqQuestions } = props;

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <div className="col-md-9 faq-section">
                  <h1 className="main-color bold">{I18n.t('page.faq.title')}</h1>
                  <h4>{I18n.t('page.faq.text')}</h4>
                  {faqQuestions.map((elem, index) => (
                    <AccordionItem
                      key={elem.id}
                      title={elem.title}
                      content={elem.content}
                      number={index + 1}
                    />
                  ))}
                </div>

                <FAQPageRightPart />

              </div>
              <MainSearch />
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

FAQPage.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
  faqQuestions: PropTypes.oneOfType([PropTypes.array]),
};
FAQPage.defaultProps = {
  footerData: {},
  faqQuestions: [],
};
export default FAQPage;
